import { SiteTheme } from "./types/types";

// TODO: Can we read values from the scss-files instead of hardcoding?
export const getLogoHeight = (
    siteTheme: SiteTheme,
    isMobile: boolean | undefined,
): number | null => {
    if (isMobile) {
        if (siteTheme === SiteTheme.GARANT) return 48; // Garant.Web\ClientApp\Static\sass\garant\_variables.scss
        if (siteTheme === SiteTheme.ELDORADO) return 26; // Garant.Web\ClientApp\Static\sass\eldorado\_overrides.scss
        if (siteTheme === SiteTheme.MINSTINGEN) return 48; // Garant.Web\ClientApp\Static\sass\minstingen\_overrides.scss
    } else {
        if (siteTheme === SiteTheme.GARANT) return 62; // Garant.Web\ClientApp\Static\sass\garant\_overrides.scss
        if (siteTheme === SiteTheme.ELDORADO) return 66; // Garant.Web\ClientApp\Static\sass\eldorado\_overrides.scss
        if (siteTheme === SiteTheme.MINSTINGEN) return 88; // Garant.Web\ClientApp\Static\sass\minstingen\_overrides.scss
    }
    return null;
};

export const getLogoWidth = (
    siteTheme: SiteTheme,
    isMobile: boolean | undefined,
): number | null => {
    if (isMobile) {
        if (siteTheme === SiteTheme.GARANT) return 48; // Garant.Web\ClientApp\Static\sass\garant\_variables.scss
        if (siteTheme === SiteTheme.ELDORADO) return 141; // Garant.Web\ClientApp\Static\sass\eldorado\_overrides.scss
        if (siteTheme === SiteTheme.MINSTINGEN) return 70; // // Garant.Web\ClientApp\Static\sass\minstingen\_overrides.scss
    } else {
        if (siteTheme === SiteTheme.GARANT) return 62; // Garant.Web\ClientApp\Static\sass\garant\_overrides.scss
        if (siteTheme === SiteTheme.ELDORADO) return 354;
        if (siteTheme === SiteTheme.MINSTINGEN) return 128;
    }
    return null;
};
